
import { get } from 'vuex-pathify'

export default {
  name: 'StoreStatus',
  computed: {
    acceptOrders: get('delivery/acceptOrders'),
    from: get('delivery/openFrom'),
    to: get('delivery/openTo'),
    canCheckout: get('delivery/canCheckout'),
    alertAttrs() {
      const { from, to } = this

      let title = 'storeClosed'
      let type = 'warning'

      if (!this.acceptOrders) {
        title = 'ordersDisabled'
        type = 'danger'
      }

      title = this.$t(`delivery.${title}`, { from, to })

      return { title, type }
    }
  }
}
